import React from 'react';

import PropTypes from 'prop-types';
import { Menu, Icon } from 'semantic-ui-react';

import { getStarColor, getStarName } from './RatingMenu.utils';
import {
  ONE_STAR_RATING,
  TWO_STAR_RATING,
  THREE_STAR_RATING,
  FOUR_STAR_RATING,
  FIVE_STAR_RATING,
} from '../../constants/ratings';

import './RatingMenu.scss';

const propTypes = {
  starRatings: PropTypes.arrayOf(PropTypes.shape({})),
  activeRating: PropTypes.number.isRequired,
  setActiveRating: PropTypes.func.isRequired,
};

const defaultProps = {
  starRatings: [
    ONE_STAR_RATING,
    TWO_STAR_RATING,
    THREE_STAR_RATING,
    FOUR_STAR_RATING,
    FIVE_STAR_RATING,
  ],
};

export default function RatingMenu({ starRatings, activeRating, setActiveRating }) {
  return (
    <Menu size="large" pointing secondary className="rating-menu">
      {starRatings.map((rating) => (
        <Menu.Item
          key={rating}
          name={getStarName(rating)}
          active={activeRating === rating}
          onClick={() => setActiveRating(rating)}
        >
          <Icon name="star" color={getStarColor(rating)} />
          {getStarName(rating)}
        </Menu.Item>
      ))}
    </Menu>
  );
}

RatingMenu.propTypes = propTypes;
RatingMenu.defaultProps = defaultProps;
